import useJwt from '@/auth/jwt/useJwt'

async function forceLogout(ability) {
  try {
    await useJwt.logout()
  } catch (e) {
    // Tetap lanjutkan pembersihan storage meski request API logout gagal
  }

  localStorage.clear()
  sessionStorage.clear()

  window.location.replace('/login')
}

export default forceLogout
